module.exports = __webpack_public_path__ + "img/a-banner1.cd409e8a.png";